module.exports = __webpack_public_path__ + "static/media/close.03797a02.svg";